import { render, staticRenderFns } from "./LogoutControl.vue?vue&type=template&id=c307addc&"
import script from "./LogoutControl.vue?vue&type=script&lang=js&"
export * from "./LogoutControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports